import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import dashboardAnalytics from '~/analytics/dashboard/dashboardAnalytics'
import CreditCardIcon from '~/components/Icons/svgs/CreditCardIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import useCurrentFamily from '~/familyAccount/hooks/useCurrentFamily'
import useCurrentUser from '~/hooks/useCurrentUser'
import { userHasCustomerPortal } from '~/redux/utils/subscription'
import { useRedirectToCustomerPortal } from '~/settings-scenario/hooks/useRedirectToCustomerPortal'

import { MenuCategoryKeys } from '../constants/category.const'
import useMenuSubscriptionState from '../hooks/useMenuSubscriptionState'

export default function SubscriptionButton({ className = '' }: { className?: string }): React.ReactElement | null {
  const { t } = useTranslation('menu')
  const user = useCurrentUser()
  const { isFamilyAdmin, isFamilyMember } = useCurrentFamily()
  const { isSubscriptionApplicable } = useMenuSubscriptionState()
  const redirectToCustomerPortal = useRedirectToCustomerPortal()
  const [isRedirecting, setIsRedirecting] = useState(false)

  const showManageSubscription =
    isSubscriptionApplicable && (isFamilyAdmin || (!isFamilyMember && userHasCustomerPortal(user)))

  if (!showManageSubscription) {
    return null
  }

  const handleClick = async (): Promise<void> => {
    dashboardAnalytics.handleHeaderTopMenuClick('BurgerMenuClick', MenuCategoryKeys.SUBSCRIPTION)
    setIsRedirecting(true)
    try {
      await redirectToCustomerPortal()
    } catch {
      setIsRedirecting(false)
    }
  }

  return (
    <button
      className={`${className} flex items-center gap-1 rounded-2 px-2.5 py-2 text-xs font-medium leading-3 text-white duration-300 hover:bg-purple-darker ${
        isRedirecting ? 'opacity-60' : ''
      }`}
      data-test-id="menu-subscription"
      disabled={isRedirecting}
      onClick={handleClick}
    >
      <SVGIcon icon={CreditCardIcon} pathClassName="text-white" size={22} />
      {t('subscription')}
    </button>
  )
}
